<div
  class="rv-card px-xlarge py-xlarge"
  [class.collapsed]="!open"
  [class.rv-pointer]="!open"
  (click)="open = true"
>
  <header class="rv-flex">
    <div class="rv-flex">
      <span class="rv-flex">
        <riv-icon *ngIf="!open" [name]="'ChevronDown'"></riv-icon>
        <riv-icon
          *ngIf="open"
          [name]="'ChevronUp'"
          class="rv-pointer"
          (click)="$event.stopPropagation(); open = false"
        ></riv-icon>
      </span>
      <h4 class="rv-title-05">{{ header }}</h4>
    </div>
    <ng-content select="[header-button]"></ng-content>
  </header>
  <span *ngIf="open">
    <ng-container *ngTemplateOutlet="contentRef"></ng-container>
  </span>
</div>
